var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-list"},_vm._l((_vm.imageList),function(item,index){return _c('img',{key:'image'+index,attrs:{"src":item,"alt":""}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }